/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Oktaacccreatesuccess3Inputs */

const en_auth_oktaacccreatesuccess3 = /** @type {(inputs: Auth_Oktaacccreatesuccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account successfully created. Re-sign in.`)
};

/**
* | output |
* | --- |
* | "Account successfully created. Re-sign in." |
*
* @param {Auth_Oktaacccreatesuccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_oktaacccreatesuccess3 = /** @type {((inputs?: Auth_Oktaacccreatesuccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Oktaacccreatesuccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_oktaacccreatesuccess3(inputs)
});
export { auth_oktaacccreatesuccess3 as "auth_oktaAccCreateSuccess" }